import {
  SET_SECTION_LIST,
  SET_SECTION_FILTER
} from "./actions";

const initialState = {
  sections: [],
  count: 0,
  filter: {
    status: "",
    limit: 10,
    skip: 0,
  },
};

const sectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SECTION_LIST:
      return {
        ...state,
        sections: action.payload.sections,
        count: action.payload.count,
      };
    case SET_SECTION_FILTER: {
      const { key, value } = action.payload;
      return {
        ...state,
        filter: {
          ...state.filter,
          [key]: value,
        },
      };
    };
    default:
      return state;
  }
};

export default sectionReducer;
